import React from 'react'
import PropTypes from 'prop-types'

import Helmet from 'components/page/Helmet'

export default function ArticleHelmet ({
  publishedDate,
  modifiedDate,
  children,
  ...others
}) {
  return (
    <Helmet
      {...others}
      metaArray={[
        <meta
          key="published"
          property="article:published_time"
          content={publishedDate}
        />,
        modifiedDate && (
          <meta
            key="modified"
            property="article:modified_time"
            content={modifiedDate}
          />
        ),
      ]}
    >
      {children}
    </Helmet>
  )
}

ArticleHelmet.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node)]),
  publishedDate: PropTypes.string.isRequired,
  modifiedDate: PropTypes.string,
  // others to support: https://ogp.me/#no_vertical
  //   expirationDate: PropTypes.string,
  //   author: PropTypes.string,
  //   section: PropTypes.string,
  //   tags: PropTypes.arrayOf(PropTypes.string),
}
